@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.other-options-wrapper {
  align-self: stretch;
}

.other-options-header {
  font-size: 14px;
}

.options-section {
  padding: 5px 15px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.header-info {
  display: inline-flex;
  flex: 1;
  justify-content: flex-end;
  font-weight: 100;
  align-items: center;
  white-space: nowrap;
}

.pill-text {
  font-size: 11px;
}

.single-pill {
  font-size: 11px;
  background-color: @other-shipping-options--header--background-color;
}

.more {
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: @other-shipping-options--more--background-color;
  margin-left: 5px;
}

.tooltip-content {
  max-width: 300px;
  display: flex;
  flex-flow: column nowrap;
}

.read-only-form {
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 14px;
}

.read-only-row {
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding: 10px 0;
}

.read-only-title {
  color: @other-shipping-options--title--text-color;
  width: 140px;
}

.read-only-value-section {
  display: inline-flex;
  flex-direction: column;
  text-align: left;
  flex: 1;

  color: @other-shipping-options--value--text-color;
}
